var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"pa-5"},[_c('v-card-title',[_vm._v("Профиль пользователя")]),_c('v-card-text',[_c('div',[_vm._v("Ваш ник: "),_c('strong',[_vm._v(_vm._s(_vm.username))])]),_c('v-btn',{staticClass:"mt-3",attrs:{"color":"red"},on:{"click":function($event){return _vm.$emit('logout')}}},[_vm._v("Выйти")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }